const vi = {
    '例子': 'Ví dụ',
}
export default vi;